export default Object.freeze({
    PAYMENT_SCHEDULE: {
        YEARLY: 'YEARLY',
        MONTHLY: 'MONTHLY',
    },
    PACKAGE: {
        PROFESSIONAL: 'PROFESSIONAL',
        BASIC: 'BASIC',
    },
})
